import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const ARCHIVE_OPPORTUNITIES_QUERY_KEY = 'archiveOpportunitiesKey';

export function useArchivedOpportunities({
	boardId,
	enabled = true,
	pageSize = 25,
	refetchInterval,
}: {
	boardId: string;
	enabled?: boolean;
	pageSize?: number;
	refetchInterval?: number;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.IOpportunity>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IOpportunity>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { pageSize, pageToken: pageParam },
					urlPath: `board/${boardId}/items/archived`,
				}),
				'GET'
			);
		},
		queryKey: [ARCHIVE_OPPORTUNITIES_QUERY_KEY, pageSize, boardId],
		refetchInterval,
		initialPageParam: '',
	});
}

export const invalidateArchivedOpportunities = () => {
	reactQueryClient.invalidateQueries({ queryKey: [ARCHIVE_OPPORTUNITIES_QUERY_KEY] });
};
